import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ScrollButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0
    };
    this.scrollStep = this.scrollStep.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
      document.getElementById('signup-button').focus();
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
      // trackLink({ id: 'brcScrollUpClick'});
      const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
      this.setState({ intervalId: intervalId });
  }

  render() {
    return (
        <button aria-label ="Back To Top" data-pa-click= "brcScrollUpClick" className="scrollupbtn"
          onClick={() => this.scrollToTop()} />
    );
  }
}
export default ScrollButton;

ScrollButton.propTypes = {
  scrollStepInPx: PropTypes.string,
  delayInMs: PropTypes.string
};
